export enum ACCOUNT_PERMISSION_LEVEL {
    SERVICE_ACCOUNT = 'service account',
    CHILD_ACCOUNT = 'child account',
    ALL = 'all',
}

export enum USER_ROLE_PERMISSION_LEVEL {
    ADMIN = 'admin',
    USER = 'user',
    ALL = 'all',
}
